import { render, staticRenderFns } from "./updateReferredBy.vue?vue&type=template&id=e48825a0&"
import script from "./updateReferredBy.vue?vue&type=script&lang=js&"
export * from "./updateReferredBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports